import React from "react";
import { MediaObject } from "../../types/MediaObject";
import _ from "lodash";
import { Box, Button, Grid, Stack } from "@mui/material";
import MimeTypeIcon from "../MediaObject/MimeTypeIcon";
import { Link } from "react-router-dom";

type AttachmentMergeMediaObjectsProps = {
  mediaObjects: Array<MediaObject>;
};

export default function AttachmentMergeMediaObjects({ mediaObjects }: AttachmentMergeMediaObjectsProps) {
  const mediaObjectGalleryLink = _.trimEnd(
    "/services/tools/gallerie?mediaObjectIds=" +
      _.reduce(mediaObjects, (result, mediaObject) => result + mediaObject.id + "-", ""),
    "-",
  );

  return (
    <Grid
      container
      direction="row"
      sx={{
        alignItems: "center",
      }}
    >
      {_.map(mediaObjects, (mediaObject) => (
        <Box sx={{ paddingRight: 2, maxWidth: 400, wordBreak: "break-all" }} key={mediaObject.id}>
          <Stack
            direction="row"
            spacing={1}
            sx={{
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <MimeTypeIcon mimeType={mediaObject.mimeType} />{" "}
            <Button
              component={Link}
              sx={{ color: "primary.main" }}
              to={mediaObjectGalleryLink + "&initialMediaObjectId=" + mediaObject.id}
              target={"_blank"}
            >
              {mediaObject.originalName}
            </Button>
          </Stack>
        </Box>
      ))}
    </Grid>
  );
}
